import registerCard from '../../../common/cards/index';
import presentationalComponent from './Card';
import containerComponent from './CardContainer';

import { isApple } from '../../utils/services/browser';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';
import { ELEMENT_FEATURES } from '../feature/elementFeatureConstants';

export default () =>
    registerCard({
        containerComponent,
        presentationalComponent,
        tools: [TOOLS.RICH_TEXT, TOOLS.COLOR, TOOLS.REACTION],
        features: [ELEMENT_FEATURES.DOCUMENT, ELEMENT_FEATURES.DESCRIPTION, ELEMENT_FEATURES.TRANSPARENT],
        tooltip: isApple ? '⌃⌘N' : 'Ctrl+Alt+N',
    });
